import {createStyles} from '@mantine/core';
import React from 'react';

const useStyles = createStyles((theme) => ({
  frameContainer: {
    borderRadius: theme.radius.md,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
  },
  iframe: {
    border: 'none',
    flex: 1,
    minHeight: 0,
    width: '100%',
  },
}));

export default function CanvasPreviewFrame({signedUrl}: {signedUrl: string}): JSX.Element {
  const {classes} = useStyles();

  return (
    <div className={classes.frameContainer}>
      <iframe sandbox="allow-scripts" src={signedUrl} className={classes.iframe} title="Canvas preview" />
    </div>
  );
}
